import CartSelector from './cart-selector-view'

export default CartSelector
